import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";
import scrollToTop from "../components/hooks/ScrollToTop";
import { useTranslation } from "react-i18next";

const Home = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  return (
    <>
      <div
        className="page-wrapper"
        data-w-id="67d54e44958467faecf80889"
        style={{ opacity: "0" }}
      >
        <Navbar />
        <section
          data-w-id="ff16e7a9-f7e3-77c2-015f-a1152daaa887"
          className="section banner"
        >
          <div className="banner-container">
            <div className="banner-content">
              <div
                data-w-id="6e58a63e-55a6-96bc-8457-502e6779cd81"
                className="banner-typography"
              >
                {/* <div className="hero-banner-subtitle-wrapper">
                  <img
                    src="/images/hero-20banner-20subtitle-20img1.webp"
                    loading="lazy"
                    alt=""
                    className="hero-banner-subtitle-img left"
                  />
                  <div className="hero-banner-subtitle-number">№1</div>
                  <div className="hero-banner-subtitle-text">
                    editor’s choice
                  </div>
                  <img
                    src="/images/hero-20banner-20subtitle-20img2.webp"
                    loading="lazy"
                    alt=""
                    className="hero-banner-subtitle-img right"
                  />
                </div> */}
                <div className="banner-title-description">
                  <h1 className="banner-title">
                    {t("yourGateway")}<br />
                    {t("toSelfInnovation")}
                  </h1>
                  <p className="banner-description-text">
                    {t("getInstantAccessToTheGlobalCommunityThatImpactingTheWorld")}
                  </p>
                </div>
                <div className="banner-button-wrapper">
                  <div className="primary-button-wrapper">
                    <a href="/JoinNow" className="inner-button w-inline-block">
                      <div className="primary-button-border-wrap">
                        <div className="inner-button-wrap">
                          <div className="inner-button-text-wrap">
                            <div className="inner-button-text">{t("getStarted")}</div>
                            <div className="inner-button-hover-text">
                              {t("getStarted")}
                            </div>
                          </div>
                          <div className="inner-button-star-wrap">
                            <img
                              loading="lazy"
                              src="/images/inner-button-star-1.svg"
                              alt=""
                              className="inner-button-star _1"
                            />
                            <img
                              loading="lazy"
                              src="/images/inner-button-star-2.svg"
                              alt=""
                              className="inner-button-star _2"
                            />
                            <img
                              loading="lazy"
                              src="/images/inner-button-star-3.svg"
                              alt=""
                              className="inner-button-star _3"
                            />
                          </div>
                          <div className="inner-button-hover-bg"></div>
                        </div>
                      </div>
                      <div className="line-wrap-inner">
                        <div className="inner-line-wrap _1">
                          <div className="line"></div>
                          <div className="line _2"></div>
                        </div>
                        <div className="inner-line-wrap _2">
                          <div className="line _3"></div>
                          <div className="line _4"></div>
                        </div>
                        <div className="inner-line-wrap _3">
                          <div className="line _5"></div>
                          <div className="line _6"></div>
                        </div>
                        <div className="inner-line-wrap _4">
                          <div className="line _7"></div>
                          <div className="line _8"></div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="banner-world-element-wrapper">
                <img
                  src="/images/banner-20world-20element.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(0.5, 0.5, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 0, 0) scale3d(0.5, 0.5, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(0.5, 0.5, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(0.5, 0.5, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  sizes="(max-width: 635px) 100vw, 635px"
                  alt=""
                  srcSet="/images/banner-20world-20element.webp 500w, /images/banner-20world-20element.webp 635w"
                  className="banner-world-element-image"
                />
                <div
                  style={{ opacity: "0" }}
                  className="banner-world-element-tag-content"
                >
                  <div className="banner-world-element-tag-wrapper">
                    <div className="banner-world-element-tag-single one">
                      <div className="banner-world-element-tag-line-name">
                        <div className="banner-world-element-tag-line"></div>
                        <div className="banner-world-element-tag-name">
                          1 ETH = $1000
                        </div>
                      </div>
                      <img
                        src="/images/banner-20world-20element-20tag-20flag1.svg"
                        loading="lazy"
                        alt=""
                        className="banner-world-element-tag-flag"
                      />
                    </div>
                    <div className="banner-world-element-tag-single two">
                      <div className="banner-world-element-tag-line-name">
                        <div className="banner-world-element-tag-line two"></div>
                        <div className="banner-world-element-tag-name">
                          1 ETH = 3177.38 CIC
                        </div>
                      </div>
                      <img
                        src="/images/banner-20world-20element-20tag-20flag2.svg"
                        loading="lazy"
                        alt=""
                        className="banner-world-element-tag-flag"
                      />
                    </div>
                    <div className="banner-world-element-tag-single three">
                      <div className="banner-world-element-tag-line-name">
                        <div className="banner-world-element-tag-line three"></div>
                        <div className="banner-world-element-tag-name">
                          3177.38 CIC = $1000
                        </div>
                      </div>
                      <img
                        src="/images/banner-20world-20element-20tag-20flag3.svg"
                        loading="lazy"
                        alt=""
                        className="banner-world-element-tag-flag"
                      />
                    </div>
                    <img
                      src="/images/noa.png"
                      loading="lazy"
                      alt=""
                      className="banner-single-element"
                    />
                  </div>
                </div>
              </div>
              <img
                src="/images/banner-20shape.webp"
                loading="lazy"
                style={{ opacity: "0" }}
                sizes="(max-width: 1520px) 100vw, 1520px"
                alt=""
                srcSet="/images/banner-20shape.webp 500w, /images/banner-20shape.webp 800w, /images/banner-2520shape-p-1080.png 1080w, /images/banner-20shape.webp 1520w"
                className="banner-shape"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="banner-pluse-icon top-left"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="banner-pluse-icon top-right"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="banner-pluse-icon bottom-left"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="banner-pluse-icon bottom-right"
              />
            </div>
          </div>
        </section>
        <section className="section headline-section">
          <div className="headline-content">
            <div className="headline-ticker">
              <div className="headline-ticker-single">
                <div className="headline-ticker-inner-ticker">
                  <h2 className="footer-ticker-name">
                    {t("brillianceBeginsWithYou")}{" "}
                  </h2>
                  <h2 className="footer-ticker-name">
                    {t("brillianceBeginsWithYou")}{" "}
                  </h2>
                </div>
                <div className="headline-ticker-inner-ticker">
                  <h2 className="footer-ticker-name">
                    {t("brillianceBeginsWithYou")}{" "}
                  </h2>
                  <h2 className="footer-ticker-name">
                    {t("brillianceBeginsWithYou")}{" "}
                  </h2>
                </div>
                <div className="headline-ticker-inner-ticker">
                  <h2 className="footer-ticker-name">
                    {t("brillianceBeginsWithYou")}{" "}
                  </h2>
                  <h2 className="footer-ticker-name">
                    {t("brillianceBeginsWithYou")}{" "}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section solving">
          <div className="container">
            <div
              data-w-id="8def8b53-36af-5862-206c-d3250cc14105"
              className="solving-section-title-wrapper"
            >
              <div
                style={{ opacity: "0" }}
                className="section-subtitle-wrapper"
              >
                <div className="section-subtitle">[ {t("technology")} ]</div>
              </div>
              <h2 style={{ opacity: "0" }} className="solving-section-title">
                {t("exploreTheAdvantagesOf")} <br />
                {t("AiAndNutrition")}{" "}
              </h2>
            </div>
            <div
              data-w-id="4ddbcaea-ba28-8428-4d80-457261bd9057"
              className="solving-content"
            >
              <div className="w-layout-grid solving-grid">
                <div className="solving-grid-single _1st">
                  <div style={{ opacity: "0" }} className="solving-card one">
                    <div className="solving-card-icon-wrapper">
                      <img
                        src="/images/solving-20card-20icon1.svg"
                        loading="lazy"
                        alt=""
                        className="solving-card-icon"
                      />
                    </div>
                    <div className="solving-card-title-description">
                      <h4 className="solving-card-title">{t("moneyPower")}</h4>
                      <p className="solving-card-description-text">
                        {t("unlockUnlimitedPowerOfMoney")}
                      </p>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-top-element"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-bottom-element"
                    />
                  </div>
                  <div className="solving-card four">
                    <div className="solving-card-icon-wrapper">
                      <img
                        src="/images/solving-20card-20icon4.svg"
                        loading="lazy"
                        alt=""
                        className="solving-card-icon"
                      />
                    </div>
                    <div className="solving-card-title-description">
                      <h4 className="solving-card-title">{t("lifeAcademy")}</h4>
                      <p className="solving-card-description-text">
                        {t("lifeAcademyDescription")}
                      </p>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-top-element"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-bottom-element"
                    />
                  </div>
                </div>
                <div
                  id="w-node-baf75690-0ea3-b0ee-d453-3abf3d4b5846-8f58cb16"
                  className="solving-grid-single _2nd"
                >
                  <div style={{ opacity: "0" }} className="solving-card two">
                    <div className="solving-card-icon-wrapper">
                      <img
                        src="/images/solving-20card-20icon2.svg"
                        loading="lazy"
                        alt=""
                        className="solving-card-icon"
                      />
                    </div>
                    <div className="solving-card-title-description">
                      <h4 className="solving-card-title">{t("ultimateSecurity")}</h4>
                      <p className="solving-card-description-text">
                        {t("ultimateSecurityDescription")}
                      </p>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-top-element"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-bottom-element"
                    />
                  </div>
                  <div className="solving-card five">
                    <div className="solving-card-icon-wrapper">
                      <img
                        src="/images/solving-20card-20icon5.svg"
                        loading="lazy"
                        alt=""
                        className="solving-card-icon"
                      />
                    </div>
                    <div className="solving-card-title-description">
                      <h4 className="solving-card-title">
                        {t("artificialIntelligenceTitle")}
                      </h4>
                      <p className="solving-card-description-text">
                        {t("artificialIntelligenceDescription")}
                      </p>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-top-element"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-bottom-element"
                    />
                  </div>
                </div>
                <div className="solving-grid-single _3rd">
                  <div style={{ opacity: "0" }} className="solving-card three">
                    <div className="solving-card-icon-wrapper">
                      <img
                        src="/images/solving-20card-20icon3.svg"
                        loading="lazy"
                        alt=""
                        className="solving-card-icon"
                      />
                    </div>
                    <div className="solving-card-title-description">
                      <h4 className="solving-card-title">
                       {t("healthOptimization")}
                      </h4>
                      <p className="solving-card-description-text">
                         {t("healthOptimizationDescription")}
                      </p>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-top-element"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-bottom-element"
                    />
                  </div>
                  <div className="solving-card six">
                    <div className="solving-card-icon-wrapper">
                      <img
                        src="/images/solving-20card-20icon6.svg"
                        loading="lazy"
                        alt=""
                        className="solving-card-icon"
                      />
                    </div>
                    <div className="solving-card-title-description">
                      <h4 className="solving-card-title">
                        {t("scientificBioactivity")}
                      </h4>
                      <p className="solving-card-description-text">
                        {t("scientificBioactivityDescription")}
                      </p>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-top-element"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="solving-card-bottom-element"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            src="/images/solving-20image.webp"
            loading="lazy"
            sizes="(max-width: 1440px) 100vw, 1440px"
            srcSet="images/solving-20image.webp 500w, images/solving-20image.webp 800w, images/solving-20image.webp 1080w, images/solving-20image.webp 1440w"
            alt=""
            className="solving-image"
          />
        </section>
        <section className="section historical-numbers">
          <div className="historical-numbers-content">
            <div className="historical-ticker top">
              <div className="historical-ticker-single left">
                <div className="headline-ticker-inner-ticker left">
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">75+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("countriesAndGrowing")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">120k+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("appDownloadsGlobally")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">200K+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("livesImpactedWorldwide")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">150+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("strategicPartnershipsGlobally")}
                    </div>
                  </div>
                </div>
                <div className="headline-ticker-inner-ticker left">
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">75+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("countriesAndGrowing")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">120k+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("appDownloadsGlobally")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">200K+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("livesImpactedWorldwide")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">150+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("strategicPartnershipsGlobally")}
                    </div>
                  </div>
                </div>
                <div className="headline-ticker-inner-ticker left">
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">75+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("countriesAndGrowing")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">120k+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("appDownloadsGlobally")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">200K+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("livesImpactedWorldwide")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">150+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("strategicPartnershipsGlobally")}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="historical-ticker bottom">
              <div className="historical-ticker-single right">
                <div className="headline-ticker-inner-ticker right">
                  {/* <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">#1</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("ratedForInnovation")}
                    </div>
                  </div> */}
                  {/* <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">95%</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("customerSatisfaction")}
                    </div>
                  </div> */}
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">500+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("leadershipEventsHosted")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">17</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("languagesAndCounting")}
                    </div>
                  </div>
                </div>
                <div className="headline-ticker-inner-ticker right">
                  {/* <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">#1</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("ratedForInnovation")}
                    </div>
                  </div> */}
                  {/* <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">95%</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("customerSatisfaction")}
                    </div>
                  </div> */}
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">500+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("leadershipEventsHosted")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">17</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("languagesAndCounting")}
                    </div>
                  </div>
                </div>
                <div className="headline-ticker-inner-ticker right">
                  {/* <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">#1</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("ratedForInnovation")}
                    </div>
                  </div> */}
                  {/* <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">95%</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("customerSatisfaction")}
                    </div>
                  </div> */}
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">500+</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("leadershipEventsHosted")}
                    </div>
                  </div>
                  <div className="historical-ticker-card">
                    <div className="historical-ticker-number-wrap">
                      <div className="historical-ticker-number">17</div>
                    </div>
                    <div className="historical-ticker-title">
                      {t("languagesAndCounting")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section features">
          <div className="container">
            <div className="features-content">
              <div
                data-w-id="8e59ac06-7b15-3b19-f5f5-8abed0e71d57"
                className="features-flex"
              >
                <div className="features-typography-card top-border-none">
                  <div className="features-typography-card-single">
                    <div className="features-subtitle-wrapper">
                      <div className="features-subtitle">
                        [ {t("artificialIntelligenceTitle")} ]
                      </div>
                    </div>
                    <div className="features-title-description">
                      <h2 className="features-title">
                        {t("empowerFuture")}
                      </h2>
                      <p className="features-description-text">
                        {t("empowerFutureText")}
                      </p>
                    </div>
                    <div className="features-button-wrapper">
                      <div className="primary-button-wrapper">
                        <a
                          href="/JoinNow"
                          className="inner-button w-inline-block"
                        >
                          <div className="primary-button-border-wrap">
                            <div className="inner-button-wrap">
                              <div className="inner-button-text-wrap">
                                <div className="inner-button-text">
                                 {t("getStarted")}
                                </div>
                                <div className="inner-button-hover-text">
                                  {t("getStarted")}
                                </div>
                              </div>
                              <div className="inner-button-star-wrap">
                                <img
                                  loading="lazy"
                                  src="/images/inner-button-star-1.svg"
                                  alt=""
                                  className="inner-button-star _1"
                                />
                                <img
                                  loading="lazy"
                                  src="/images/inner-button-star-2.svg"
                                  alt=""
                                  className="inner-button-star _2"
                                />
                                <img
                                  loading="lazy"
                                  src="/images/inner-button-star-3.svg"
                                  alt=""
                                  className="inner-button-star _3"
                                />
                              </div>
                              <div className="inner-button-hover-bg"></div>
                            </div>
                          </div>
                          <div className="line-wrap-inner">
                            <div className="inner-line-wrap _1">
                              <div className="line"></div>
                              <div className="line _2"></div>
                            </div>
                            <div className="inner-line-wrap _2">
                              <div className="line _3"></div>
                              <div className="line _4"></div>
                            </div>
                            <div className="inner-line-wrap _3">
                              <div className="line _5"></div>
                              <div className="line _6"></div>
                            </div>
                            <div className="inner-line-wrap _4">
                              <div className="line _7"></div>
                              <div className="line _8"></div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape top-left"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape top-right"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape bottom-left"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-card-shape-bottom-right"
                  />
                </div>
                <div className="features-card-image-wrapper">
                  <img
                    src="/images/features-20card-20image1.webp"
                    loading="lazy"
                    style={{ opacity: "0" }}
                    data-w-id="28b56001-a0e7-4223-c063-ae0af01b28ee"
                    alt=""
                    className="features-card-image"
                  />
                </div>
              </div>
              <div
                data-w-id="ebd5f07d-eafe-59e0-f034-e156826266d1"
                className="features-flex"
              >
                <div className="features-card-image-wrapper">
                  <img
                    src="/images/features-20card-20image2.webp"
                    loading="lazy"
                    style={{ opacity: "0" }}
                    data-w-id="ebd5f07d-eafe-59e0-f034-e156826266f6"
                    alt=""
                    className="features-card-image two"
                  />
                </div>
                <div className="features-typography-card">
                  <div className="features-typography-card-single">
                    <div className="features-subtitle-wrapper">
                      <div className="features-subtitle">[ {t("development")} ]</div>
                    </div>
                    <div className="features-title-description mb40">
                      <h2 className="features-title">
                        {t("personalGrowthCommunity")}
                      </h2>
                      <p className="features-description-text">
                       {t("guidedGrowthSupport")}
                      </p>
                    </div>
                    <div className="features-list-wrapper">
                      <ul role="list" className="features-list">
                        <li className="features-list-item">
                          <img
                            src="/images/features-20list-20item-20icon.svg"
                            loading="lazy"
                            alt=""
                            className="features-list-item-icon"
                          />
                          <div className="features-list-item-text">
                            {t("growthClarityConfidence")}
                          </div>
                        </li>
                        <li className="features-list-item">
                          <img
                            src="/images/features-20list-20item-20icon.svg"
                            loading="lazy"
                            alt=""
                            className="features-list-item-icon"
                          />
                          <div className="features-list-item-text">
                           {t("growthHabitsResilience")}
                          </div>
                        </li>
                        <li className="features-list-item">
                          <img
                            src="/images/features-20list-20item-20icon.svg"
                            loading="lazy"
                            alt=""
                            className="features-list-item-icon"
                          />
                          <div className="features-list-item-text">
                            {t("growthCommunitySupport")}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape top-right"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape bottom-left"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-card-shape-bottom-right"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape top-left"
                  />
                </div>
              </div>
              <div
                data-w-id="13d6c07f-4a33-8d62-06ff-903db291555a"
                className="features-flex"
              >
                <div className="features-typography-card">
                  <div className="features-typography-card-single">
                    <div className="features-subtitle-wrapper">
                      <div className="features-subtitle">[ {t("security")} ]</div>
                    </div>
                    <div className="features-title-description">
                      <h2 className="features-title">
                        {t("secureAffiliateSystem")}
                      </h2>
                      <p className="features-description-text">
                        {t("enterpriseGradeProtection")}
                      </p>
                    </div>
                    <div className="features-single-card">
                      <div className="features-single">
                        <div className="features-card-icon-wrap">
                          <img
                            src="/images/features-20card-20icon1.svg"
                            loading="lazy"
                            alt=""
                            className="features-card-icon"
                          />
                        </div>
                        <div className="features-card-title-description">
                          <h4 className="features-card-title">{t("security").toUpperCase()}</h4>
                          <p className="features-card-description">
                           {t("twoFactorProtection")}
                          </p>
                        </div>
                      </div>
                      <div className="features-single">
                        <div className="features-card-icon-wrap">
                          <img
                            src="/images/features-20card-20icon2.svg"
                            loading="lazy"
                            alt=""
                            className="features-card-icon"
                          />
                        </div>
                        <div className="features-card-title-description">
                          <h4 className="features-card-title">
                            {t("ethicalConduct").toUpperCase()}
                          </h4>
                          <p className="features-card-description">
                            {t("ethicalGuarantee")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape top-left"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape top-right"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-typography-card-shape bottom-left"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="features-card-shape-bottom-right"
                  />
                </div>
                <div className="features-card-image-wrapper">
                  <img
                    src="/images/features-20card-20image3.webp"
                    loading="lazy"
                    style={{ opacity: "0" }}
                    data-w-id="13d6c07f-4a33-8d62-06ff-903db2915580"
                    alt=""
                    className="features-card-image three"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section community-spotlight">
          <div
            data-w-id="5b30ccf4-9c4d-b796-8be3-2831dab6d2ae"
            className="community-spotlight-content"
          >
            <div className="community-spotlight-typography">
              <div className="community-spotlight-icon-wrapper">
                <img
                  src="/images/community-20spotlight-20icon.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: "0",
                  }}
                  alt=""
                  className="community-spotlight-icon"
                />
              </div>
              <div
                style={{
                  opacity: 0,
                  WebkitTransform:
                    "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform:
                    "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform:
                    "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform:
                    "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                }}
                className="community-spotlight-title-description"
              >
                <h2 className="community-spotlight-title">
                  {t("yourFutureShould")} <br /> {t("BeDefinedByYou")}{" "}
                </h2>
                <p className="community-spotlight-description">
                  {t("createOptimizeDominateAIforDigitalMarketingSuccess")}
                </p>
              </div>
              <img
                src="/images/community-20spotlight-20shape.webp"
                loading="lazy"
                style={{ opacity: "0" }}
                sizes="(max-width: 536px) 100vw, 536px"
                alt=""
                srcSet="images/community-2520spotlight-2520shape-p-500.png 500w, images/community-20spotlight-20shape.webp 536w"
                className="community-spotlight-shape"
              />
            </div>
            <div
              data-w-id="f5204fb9-5501-c729-be95-6f1e3f47b79b"
              className="community-spotlight-image-wrap"
            >
              <img
                src="/images/community-20spotlight-20bg.webp"
                loading="lazy"
                sizes="(max-width: 1437px) 100vw, 1437px"
                srcSet="images/community-20spotlight-20bg.webp 500w, images/community-20spotlight-20bg.webp 800w, images/community-20spotlight-20bg.webp 1080w, images/community-20spotlight-20bg.webp 1437w"
                alt=""
                className="community-spotlight-image-bg-shape"
              />
              <div className="community-spotlight-top-images">
                <img
                  src="/images/community-20spotlight-20img1.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _1"
                />
                <img
                  src="/images/community-20spotlight-20img2.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _2"
                />
                <img
                  src="/images/community-20spotlight-20img3.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _3"
                />
                <img
                  src="/images/community-20spotlight-20img4.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _4"
                />
                <img
                  src="/images/community-20spotlight-20img5.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _5"
                />
                <img
                  src="/images/community-20spotlight-20img6.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _6"
                />
                <img
                  src="/images/community-20spotlight-20img7.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _7"
                />
              </div>
              <div className="community-spotlight-bottom-images">
                <img
                  src="/images/community-20spotlight-20image8.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _8"
                />
                <img
                  src="/images/community-20spotlight-20image9.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _9"
                />
                <img
                  src="/images/community-20spotlight-20image10.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _10"
                />
                <img
                  src="/images/community-20spotlight-20image11.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _11"
                />
                <img
                  src="/images/community-20spotlight-20image12.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _12"
                />
                <img
                  src="/images/community-20spotlight-20image13.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _13"
                />
                <img
                  src="/images/community-20spotlight-20image14.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _14"
                />
                <img
                  src="/images/community-20spotlight-20image15.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _15"
                />
                <img
                  src="/images/community-20spotlight-20image16.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _16"
                />
                <img
                  src="/images/community-20spotlight-20image17.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _17"
                />
                <img
                  src="/images/community-20spotlight-20image18.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0,
                  }}
                  alt=""
                  className="community-spotlight-image _18"
                />
              </div>
            </div>
            <div className="community-spotlight-button-wrapper">
              <div className="primary-button-wrapper">
                <a href="/JoinNow" className="inner-button w-inline-block">
                  <div className="primary-button-border-wrap">
                    <div className="inner-button-wrap">
                      <div className="inner-button-text-wrap">
                        <div className="inner-button-text">
                          {t("JoinTheCommunity")}
                        </div>
                        <div className="inner-button-hover-text">
                          {t("JoinTheCommunity")}
                        </div>
                      </div>
                      <div className="inner-button-star-wrap">
                        <img
                          loading="lazy"
                          src="/images/inner-button-star-1.svg"
                          alt=""
                          className="inner-button-star _1"
                        />
                        <img
                          loading="lazy"
                          src="/images/inner-button-star-2.svg"
                          alt=""
                          className="inner-button-star _2"
                        />
                        <img
                          loading="lazy"
                          src="/images/inner-button-star-3.svg"
                          alt=""
                          className="inner-button-star _3"
                        />
                      </div>
                      <div className="inner-button-hover-bg"></div>
                    </div>
                  </div>
                  <div className="line-wrap-inner">
                    <div className="inner-line-wrap _1">
                      <div className="line"></div>
                      <div className="line _2"></div>
                    </div>
                    <div className="inner-line-wrap _2">
                      <div className="line _3"></div>
                      <div className="line _4"></div>
                    </div>
                    <div className="inner-line-wrap _3">
                      <div className="line _5"></div>
                      <div className="line _6"></div>
                    </div>
                    <div className="inner-line-wrap _4">
                      <div className="line _7"></div>
                      <div className="line _8"></div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section className="section core-features">
          <div className="core-features-content">
            <div className="core-features-top-content">
              <div className="container">
                <div
                  data-w-id="420a1899-7eef-4d96-9f99-7b85a323b2e3"
                  style={{ opacity: "0" }}
                  className="core-features-section-title-wrapper"
                >
                  <div className="section-subtitle-wrapper">
                    <div className="section-subtitle">[ {t("keyFeatures")} ]</div>
                  </div>
                  <h2 className="section-title core-features">
                    {t("innovationForEntrepreneurs")}
                  </h2>
                </div>
              </div>
            </div>
            <div
              data-w-id="7ec9eeb1-d14f-e027-84d5-a0215ce062f5"
              style={{ opacity: "0" }}
              className="core-features-bottom-content"
            >
              <div
                data-delay="4000"
                data-animation="slide"
                className="core-features-slider w-slider"
                data-autoplay="false"
                data-easing="ease"
                data-hide-arrows="false"
                data-disable-swipe="false"
                data-autoplay-limit="0"
                data-nav-spacing="3"
                data-duration="500"
                data-infinite="true"
              >
                <div className="core-features-mask w-slider-mask">
                  <div className="core-features-single-slide w-slide">
                    <div className="core-features-slider-card">
                      <div className="core-features-slider-card-image-wrap">
                        <img
                          src="/images/core-20features-20slider-20card-20image1.webp"
                          loading="lazy"
                          alt=""
                          className="core-features-slider-card-image"
                        />
                      </div>
                      <div className="core-features-card-title-description">
                        <h4 className="core-features-card-title">
                          {t("unlockInnovation")}
                        </h4>
                        <p className="core-features-card-description-text">
                          {t("unlockInnovationText")}
                        </p>
                      </div>
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line top-left"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line top-right"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line bottom-left"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line bottom-right"
                      />
                      <div className="core-features-slider-card-number">
                        [ 01 ]
                      </div>
                    </div>
                  </div>
                  <div className="core-features-single-slide w-slide">
                    <div className="core-features-slider-card">
                      <div className="core-features-slider-card-image-wrap">
                        <img
                          src="/images/core-20features-20slider-20card-20image2.webp"
                          loading="lazy"
                          alt=""
                          className="core-features-slider-card-image"
                        />
                      </div>
                      <div className="core-features-card-title-description">
                        <h4 className="core-features-card-title _2nd">
                          {t("connectAndGrow")}
                        </h4>
                        <p className="core-features-card-description-text">
                          {t("connectAndGrowText")}
                        </p>
                      </div>
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line top-left"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line top-right"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line bottom-left"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line bottom-right"
                      />
                      <div className="core-features-slider-card-number">
                        [ 02 ]
                      </div>
                    </div>
                  </div>
                  <div className="core-features-single-slide w-slide">
                    <div className="core-features-slider-card">
                      <div className="core-features-slider-card-image-wrap">
                        <img
                          src="/images/core-20features-20slider-20card-20image3.webp"
                          loading="lazy"
                          alt=""
                          className="core-features-slider-card-image"
                        />
                      </div>
                      <div className="core-features-card-title-description">
                        <h4 className="core-features-card-title _3rd">
                          {t("leadWithConfidence")}
                        </h4>
                        <p className="core-features-card-description-text">
                          {t("leadWithConfidenceText")}
                        </p>
                      </div>
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line top-left"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line top-right"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line bottom-left"
                      />
                      <img
                        src=""
                        loading="lazy"
                        alt=""
                        className="core-features-slider-card-line bottom-right"
                      />
                      <div className="core-features-slider-card-number">
                        [ 03 ]
                      </div>
                    </div>
                  </div>
                </div>
                <div className="core-features-slider-arrow left w-slider-arrow-left">
                  <div className="core-features-slider-arrow-wrap">
                    <img
                      src="/images/core-20features-20slider-20left-20arrow.svg"
                      loading="lazy"
                      alt=""
                      className="core-features-slider-arrow-icon"
                    />
                  </div>
                </div>
                <div className="core-features-slider-arrow right w-slider-arrow-right">
                  <div className="core-features-slider-arrow-wrap">
                    <img
                      src="/images/core-20features-20slider-20right-20arrow.svg"
                      loading="lazy"
                      alt=""
                      className="core-features-slider-arrow-icon"
                    />
                  </div>
                </div>
                <div className="core-features-slide-nav w-slider-nav w-round w-num"></div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="section testimonial">
          <div
            data-w-id="d1c43377-0abd-fb74-1663-3b34e3b073f7"
            className="testimonial-content"
          >
            <div className="testimonial-wrapper">
              <div className="container">
                <div className="section-subtitle-wrapper center">
                  <div className="section-subtitle">[ {t('WhatTheyreSaying')} ]</div>
                </div>
                <div className="testimonial-section-title-wrapper">
                  <div className="testimonial-section-title-single">
                    <h2 className="section-title">
                      {t('WhatMembersSayingAboutNoa')}
                    </h2>
                  </div>
                  <div className="testimonial-section-button-wrap">
                    <div className="primary-button-wrapper">
                      <a href="#" className="inner-button w-inline-block">
                        <div className="primary-button-border-wrap">
                          <div className="inner-button-wrap">
                            <div className="inner-button-text-wrap">
                              <div className="inner-button-text">
                                {t('readTestimonials')}
                              </div>
                              <div className="inner-button-hover-text">
                                {t('readTestimonials')}
                              </div>
                            </div>
                            <div className="inner-button-star-wrap">
                              <img
                                loading="lazy"
                                src="/images/inner-button-star-1.svg"
                                alt=""
                                className="inner-button-star _1"
                              />
                              <img
                                loading="lazy"
                                src="/images/inner-button-star-2.svg"
                                alt=""
                                className="inner-button-star _2"
                              />
                              <img
                                loading="lazy"
                                src="/images/inner-button-star-3.svg"
                                alt=""
                                className="inner-button-star _3"
                              />
                            </div>
                            <div className="inner-button-hover-bg"></div>
                          </div>
                        </div>
                        <div className="line-wrap-inner">
                          <div className="inner-line-wrap _1">
                            <div className="line"></div>
                            <div className="line _2"></div>
                          </div>
                          <div className="inner-line-wrap _2">
                            <div className="line _3"></div>
                            <div className="line _4"></div>
                          </div>
                          <div className="inner-line-wrap _3">
                            <div className="line _5"></div>
                            <div className="line _6"></div>
                          </div>
                          <div className="inner-line-wrap _4">
                            <div className="line _7"></div>
                            <div className="line _8"></div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="testimonial-top-content">
                <div className="testimonial-top-left-card">
                  <div className="testimonial-single-card one">
                    <div className="testimonial-description-wrapper">
                      <p className="testimonial-description-text">
                        {t('testimonial')}
                      </p>
                    </div>
                    <div className="testimonial-author-wrapper">
                      <div className="testimonial-author-image-wrap">
                        <img
                          src="/images/testimonial-20author-20image2.webp"
                          loading="lazy"
                          alt=""
                          className="testimonial-author-image"
                        />
                      </div>
                      <div className="testimonial-author-name-bio-wrapper">
                        <h6 className="testimonial-author-name">{t('alexr')}</h6>
                        <div className="testimonial-author-bio">
                          {t('entrepreneur')}
                        </div>
                      </div>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-right"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-right"
                    />
                  </div>
                  <div className="testimonial-single-card two">
                    <div className="testimonial-description-wrapper">
                      <p className="testimonial-description-text">
                        {t('theAppsToolsFromNoaIntuitive')}
                      </p>
                    </div>
                    <div className="testimonial-author-wrapper">
                      <div className="testimonial-author-image-wrap">
                        <img
                          src="/images/testimonial-20author-20image1.webp"
                          loading="lazy"
                          alt=""
                          className="testimonial-author-image"
                        />
                      </div>
                      <div className="testimonial-author-name-bio-wrapper">
                        <h6 className="testimonial-author-name">Sophia M.</h6>
                        <div className="testimonial-author-bio">
                          {t('businessOwner')}
                        </div>
                      </div>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-right"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-right"
                    />
                  </div>
                </div>
                <div className="testimonial-top-right-card">
                  <div className="testimonial-single-card three">
                    <div className="testimonial-description-wrapper">
                      <p className="testimonial-description-text">
                        {t('rev1')}
                      </p>
                    </div>
                    <div className="testimonial-author-wrapper">
                      <div className="testimonial-author-image-wrap">
                        <img
                          src="/images/testimonial-20author-20image4.webp"
                          loading="lazy"
                          alt=""
                          className="testimonial-author-image"
                        />
                      </div>
                      <div className="testimonial-author-name-bio-wrapper">
                        <h6 className="testimonial-author-name">Daniel K.</h6>
                        <div className="testimonial-author-bio">
                          {t('digitalMarketer')}
                        </div>
                      </div>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-right"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-right"
                    />
                  </div>
                </div>
              </div>
              <div className="testimonial-bottom-content">
                <div className="testimonial-bottom-left-card">
                  <div className="testimonial-single-card four">
                    <div className="testimonial-description-wrapper">
                      <p className="testimonial-description-text">
                        {t('rev2')}
                      </p>
                    </div>
                    <div className="testimonial-author-wrapper">
                      <div className="testimonial-author-image-wrap">
                        <img
                          src="/images/testimonial-20author-20image3.webp"
                          loading="lazy"
                          alt=""
                          className="testimonial-author-image"
                        />
                      </div>
                      <div className="testimonial-author-name-bio-wrapper">
                        <h6 className="testimonial-author-name">Elena P.</h6>
                        <div className="testimonial-author-bio">
                          {t('brandAffiliate')}
                        </div>
                      </div>
                    </div>
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line top-right"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-left"
                    />
                    <img
                      src=""
                      loading="lazy"
                      alt=""
                      className="testimonial-line bottom-right"
                    />
                  </div>
                </div>
                <div className="testimonial-single-card five">
                  <div className="testimonial-description-wrapper">
                    <p className="testimonial-description-text">
                      {t('rev3')}
                    </p>
                  </div>
                  <div className="testimonial-author-wrapper">
                    <div className="testimonial-author-image-wrap">
                      <img
                        src="/images/testimonial-20author-20image5.webp"
                        loading="lazy"
                        alt=""
                        className="testimonial-author-image"
                      />
                    </div>
                    <div className="testimonial-author-name-bio-wrapper">
                      <h6 className="testimonial-author-name">Ryan T.</h6>
                      <div className="testimonial-author-bio">
                        {t('growthPartner')}
                      </div>
                    </div>
                  </div>
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="testimonial-line top-left"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="testimonial-line top-right"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="testimonial-line bottom-left"
                  />
                  <img
                    src=""
                    loading="lazy"
                    alt=""
                    className="testimonial-line bottom-right"
                  />
                </div>
              </div>
              <img
                src="/images/testimonial-20world-20img.webp"
                loading="lazy"
                sizes="(max-width: 540px) 100vw, 540px"
                srcSet="images/testimonial-20world-20img.webp 500w, images/testimonial-20world-20img.webp 540w"
                alt=""
                className="testimonial-world-img"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="testimonial-pluse top-left"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="testimonial-pluse top-right"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="testimonial-pluse bottom-left"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="testimonial-pluse bottom-right"
              />
            </div>
          </div>
        </section> */}
        {/* <section className="section company-section">
          <div className="company-wrapper">
            <div className="company-content">
              <div className="company-title-wrapper">
                <h6 className="company-title">Partnered with 150+ companies</h6>
              </div>
              <div className="sponsors-ticker">
                <div className="ticker">
                  <div className="inner-ticker-wrapper">
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img1.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img2.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img3.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img4.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img5.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img6.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img7.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                  </div>
                  <div className="inner-ticker-wrapper">
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img1.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img2.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img3.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img4.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img5.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img6.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img7.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                  </div>
                  <div className="inner-ticker-wrapper">
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img1.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img2.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img3.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img4.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img5.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img6.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                    <img
                      loading="lazy"
                      src="/images/single-20sponsor-20img7.svg"
                      alt=""
                      className="single-sponsor-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section className="section blog">
          <div className="container">
            <div data-w-id="fe1bd8f8-3c94-2117-a209-390da42c4ba7" style={{ opacity: "0" }} className="section-subtitle-wrapper center">
              <div className="section-subtitle">[ Blogs ]</div>
            </div>
            <div data-w-id="4506fba7-19f7-e7c4-e24d-3bc1f667ed32" style={{ opacity: "0" }}
              className="testimonial-section-title-wrapper blog-section-title-wrapper">
              <div className="testimonial-section-title-single">
                <h2 className="section-title">Read our articles written by professional.</h2>
              </div>
              <div className="testimonial-section-button-wrap">
                <div className="primary-button-wrapper"><a href="/blog" className="inner-button w-inline-block">
                  <div className="primary-button-border-wrap">
                    <div className="inner-button-wrap">
                      <div className="inner-button-text-wrap">
                        <div className="inner-button-text">EXPLORE blogs</div>
                        <div className="inner-button-hover-text">EXPLORE blogs</div>
                      </div>
                      <div className="inner-button-star-wrap"><img loading="lazy" src="/images/inner-button-star-1.svg"
                        alt="" className="inner-button-star _1" /><img loading="lazy"
                          src="/images/inner-button-star-2.svg" alt="" className="inner-button-star _2" /><img
                          loading="lazy" src="/images/inner-button-star-3.svg" alt="" className="inner-button-star _3" />
                      </div>
                      <div className="inner-button-hover-bg"></div>
                    </div>
                  </div>
                  <div className="line-wrap-inner">
                    <div className="inner-line-wrap _1">
                      <div className="line"></div>
                      <div className="line _2"></div>
                    </div>
                    <div className="inner-line-wrap _2">
                      <div className="line _3"></div>
                      <div className="line _4"></div>
                    </div>
                    <div className="inner-line-wrap _3">
                      <div className="line _5"></div>
                      <div className="line _6"></div>
                    </div>
                    <div className="inner-line-wrap _4">
                      <div className="line _7"></div>
                      <div className="line _8"></div>
                    </div>
                  </div>
                </a></div>
              </div>
            </div>
            <div data-w-id="d6054aac-651c-99f6-4b22-dd8b93f1d08d" style={{ opacity: "0" }} className="blog-post-content">
              <div className="w-layout-grid blog-post-grid">
                <div className="blog-post-left">
                  <div className="blog-post-collection-list-wrapper w-dyn-list">
                    <div role="list" className="blog-post-collection-list w-dyn-items">
                      <div role="listitem" className="blog-post-collection-item w-dyn-item">
                        <div className="blog-left-post">
                          <div className="blog-left-post-tag-image-wrap">
                            <div className="blog-post-tag-wrap">
                              <div className="blog-post-tag-name">Blockchain</div>
                            </div><a data-w-id="d361aa08-e690-ecd7-c421-0152849f0136"
                              href="/blog/the-future-of-the-internet-why-web3-is-the-next-big-revolution"
                              className="blog-post-image-link-block w-inline-block"><img
                                src="/images/main-20blog-20image4.jpg" loading="lazy"
                                style={{
                                  WebkitTransform: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                  MozTransform: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                  msTransform: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                  transform: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                                }}
                                alt="" className="blog-post-image" /></a>
                          </div>
                          <div className="blog-left-post-typography">
                            <div className="blog-left-post-name-wrap"><a
                              href="/blog/the-future-of-the-internet-why-web3-is-the-next-big-revolution"
                              className="blog-left-post-name">The future of the internet: why web3 is the next big
                              revolution.</a></div>
                            <div className="blog-post-author-wrapper">
                              <div className="blog-post-author-image-information"><img
                                src="/images/blog-20post-20author-20image.png" loading="lazy" alt=""
                                className="blog-post-author-image" />
                                <div className="blog-post-author-name-bio">
                                  <div className="blog-post-author-name">Robert Fox</div>
                                  <div className="blog-post-author-bio">Editor</div>
                                </div>
                              </div>
                              <div className="blog-post-date-wrap">
                                <div className="blog-post-date-text">[</div>
                                <div className="blog-post-date-text">March 24, 2025</div>
                                <div className="blog-post-date-text">]</div>
                              </div>
                            </div>
                          </div><img src="" loading="lazy" alt=""
                            className="blog-post-top-left-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-top-right-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-bottom-left-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-bottom-right-shape" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="blog-post-right">
                  <div className="blog-post-collection-list-wrapper w-dyn-list">
                    <div role="list" className="blog-post-collection-right-side-list w-dyn-items">
                      <div role="listitem" className="blog-post-collection-item w-dyn-item">
                        <div className="blog-post-collection-right-side-single">
                          <div className="blog-post-tag-wrap right-side">
                            <div className="blog-post-tag-name">Blockchain</div>
                          </div>
                          <div className="blog-left-post-name-wrap mb80"><a
                            href="/blog/why-decentralization-matters-the-power-of-blockchain-technology"
                            className="blog-left-post-name">Why decentralization matters: the power of blockchain
                            technology.</a></div>
                          <div className="blog-post-author-wrapper">
                            <div className="blog-post-author-image-information"><img
                              src="/images/blog-20post-20author-20image.png" loading="lazy" alt=""
                              className="blog-post-author-image" />
                              <div className="blog-post-author-name-bio">
                                <div className="blog-post-author-name">Robert Fox</div>
                                <div className="blog-post-author-bio">Editor</div>
                              </div>
                            </div>
                            <div className="blog-post-date-wrap">
                              <div className="blog-post-date-text">[</div>
                              <div className="blog-post-date-text">March 24, 2025</div>
                              <div className="blog-post-date-text">]</div>
                            </div>
                          </div><img src="" loading="lazy" alt=""
                            className="blog-post-bottom-right-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-bottom-left-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-top-right-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-top-left-shape" />
                        </div>
                      </div>
                      <div role="listitem" className="blog-post-collection-item w-dyn-item">
                        <div className="blog-post-collection-right-side-single">
                          <div className="blog-post-tag-wrap right-side">
                            <div className="blog-post-tag-name">Blockchain</div>
                          </div>
                          <div className="blog-left-post-name-wrap mb80"><a
                            href="/blog/ethereum-vs-solana-vs-polygon-which-blockchain-is-right-for-you"
                            className="blog-left-post-name">Ethereum vs. Solana vs. Polygon: which blockchain is right for
                            you?</a></div>
                          <div className="blog-post-author-wrapper">
                            <div className="blog-post-author-image-information"><img
                              src="/images/blog-20post-20author-20image.png" loading="lazy" alt=""
                              className="blog-post-author-image" />
                              <div className="blog-post-author-name-bio">
                                <div className="blog-post-author-name">Robert Fox</div>
                                <div className="blog-post-author-bio">Editor</div>
                              </div>
                            </div>
                            <div className="blog-post-date-wrap">
                              <div className="blog-post-date-text">[</div>
                              <div className="blog-post-date-text">March 24, 2025</div>
                              <div className="blog-post-date-text">]</div>
                            </div>
                          </div><img src="" loading="lazy" alt=""
                            className="blog-post-bottom-right-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-bottom-left-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-top-right-shape" /><img
                            src="" loading="lazy" alt=""
                            className="blog-post-top-left-shape" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section
          data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d72e"
          className="section cta"
        >
          <div className="container">
            <div className="cta-content">
              <div
                data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d731"
                className="cta-typography"
              >
                <div className="cta-title-description">
                  <h2 className="cta-title">
                    {t('EmbraceFutureScienceTechnology')}
                  </h2>
                  <p className="cta-description-text">
                    {t('becomeYourself')}
                    <br />
                    {t('byEvolve')}
                    <br />
                    {t('yourHealth')}
                  </p>
                </div>
                <div className="cta-button-wrapper">
                  <div className="primary-button-wrapper">
                    <a href="/JoinNow" className="inner-button w-inline-block">
                      <div className="primary-button-border-wrap">
                        <div className="inner-button-wrap">
                          <div className="inner-button-text-wrap">
                            <div className="inner-button-text">
                              {t('getStartedNow')}
                            </div>
                            <div className="inner-button-hover-text">
                              {t('getStartedNow')}
                            </div>
                          </div>
                          <div className="inner-button-star-wrap">
                            <img
                              loading="lazy"
                              src="/images/inner-button-star-1.svg"
                              alt=""
                              className="inner-button-star _1"
                            />
                            <img
                              loading="lazy"
                              src="/images/inner-button-star-2.svg"
                              alt=""
                              className="inner-button-star _2"
                            />
                            <img
                              loading="lazy"
                              src="/images/inner-button-star-3.svg"
                              alt=""
                              className="inner-button-star _3"
                            />
                          </div>
                          <div className="inner-button-hover-bg"></div>
                        </div>
                      </div>
                      <div className="line-wrap-inner">
                        <div className="inner-line-wrap _1">
                          <div className="line"></div>
                          <div className="line _2"></div>
                        </div>
                        <div className="inner-line-wrap _2">
                          <div className="line _3"></div>
                          <div className="line _4"></div>
                        </div>
                        <div className="inner-line-wrap _3">
                          <div className="line _5"></div>
                          <div className="line _6"></div>
                        </div>
                        <div className="inner-line-wrap _4">
                          <div className="line _7"></div>
                          <div className="line _8"></div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <img
                src=""
                loading="lazy"
                alt=""
                className="cta-top-left-element"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="cta-top-right-element"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="cta-bottom-left-element"
              />
              <img
                src=""
                loading="lazy"
                alt=""
                className="cta-bottom-right-element"
              />
              <img
                src="/images/cta-20shape.webp"
                loading="lazy"
                data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d752"
                sizes="(max-width: 537px) 100vw, 537px"
                alt=""
                srcSet="images/cta-2520shape-p-500.png 500w, images/cta-20shape.webp 537w"
                className="cta-shape"
              />
              <img
                src="/images/cta-20elment1.webp"
                loading="lazy"
                data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d753"
                alt=""
                className="cta-elment-one"
              />
              <img
                src="/images/cta-20elment2.webp"
                loading="lazy"
                data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d754"
                alt=""
                className="cta-elment-two"
              />
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default Home;
